import { render, staticRenderFns } from "./Concierge.vue?vue&type=template&id=3f328630&scoped=true&"
import script from "./Concierge.vue?vue&type=script&lang=js&"
export * from "./Concierge.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=3f328630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f328630",
  null
  
)

export default component.exports